/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Hours, Minutes, Seconds, Time, TimeUtils } from '@wit/vtv-x-foundation-lib';
import translate from 'services/i18n/translate';

/**
 *
 * @param selectedDay
 * @returns Today; yesterday; tomorrow or any other day of the week.
 */
export function getDayName(selectedDay: Time): string {
  const now = TimeUtils.now();

  if (TimeUtils.isToday(selectedDay)) {
    return translate['date.today'];
  }

  if (TimeUtils.isSameDay(TimeUtils.addDays(now, 1), selectedDay)) {
    return translate['date.tomorrow'];
  }

  if (TimeUtils.isSameDay(TimeUtils.subDays(now, 1), selectedDay)) {
    return translate['date.yesterday'];
  }
  return TimeUtils.getLongWeekDay(TimeUtils.parse(selectedDay));
}

export function convertHMS(value: Seconds): string {
  if (!Number.isFinite(value)) {
    return '00:00:00';
  }
  const sec = Math.trunc(value);
  const hours: Hours = Math.floor(sec / 3600); // get hours
  const minutes: Minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
  const seconds: Seconds = sec - hours * 3600 - minutes * 60; //  get seconds
  // add 0 if value < 10; Example: 2 => 02
  let renderHours: string = hours.toString();
  let renderMinutes: string = minutes.toString();
  let renderSeconds: string = seconds.toString();

  if (hours < 10) {
    renderHours = `0${hours}`;
  }
  if (minutes < 10) {
    renderMinutes = `0${minutes}`;
  }
  if (seconds < 10) {
    renderSeconds = `0${seconds}`;
  }
  return `${renderHours}:${renderMinutes}:${renderSeconds}`; // Return is HH : MM : SS
}
